import React from 'react';
import { motion } from 'framer-motion';
interface PhotoCarouselProps {
  photos: string[];
}
export function PhotoCarousel({
  photos
}: PhotoCarouselProps) {
  // Duplicate photos for seamless infinite scroll
  const duplicatedPhotos = [...photos, ...photos, ...photos];
  return <div className="relative overflow-hidden -mx-6 print:hidden" data-id="element-43">
      <div className="absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-white to-transparent z-10" data-id="element-44" />
      <div className="absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-white to-transparent z-10" data-id="element-45" />

      <motion.div className="flex gap-4" animate={{
      x: [0, -1 * (photos.length * 320)]
    }} transition={{
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 30,
        ease: 'linear'
      }
    }} data-id="element-46">
        {duplicatedPhotos.map((photo, idx) => <div key={idx} className="flex-shrink-0 w-80 h-80 rounded-lg overflow-hidden grayscale hover:grayscale-0 transition-all duration-500" data-id="element-47">
            <img src={photo} alt={`Photo ${idx + 1}`} className="w-full h-full object-cover" data-id="element-48" />
          </div>)}
      </motion.div>
    </div>;
}